import React from "react";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import "./Navbar.scss";
import { Box, IconButton } from "@mui/material";
import { useHttp } from "../../hooks/useHttp";
import { useLocation } from "react-router";
import HelpIcon from "@mui/icons-material/Help";
import { HelpType } from "../Help/Help";
const background = require("../../images/background.png");

interface NavbarInterface {
  authenticated: boolean;
  setAuthenticated: (authenticated: boolean) => void;
  setHelp: React.Dispatch<React.SetStateAction<HelpType>>;
}

export const Navbar = ({ authenticated, setAuthenticated, setHelp }: NavbarInterface) => {
  const { trigger: logout } = useHttp<Response>("/logout");
  const location = useLocation();
  const isHome = location.pathname === "/";

  const handleHelpClick = () => {
    switch (location.pathname) {
      case "/":
        setHelp(HelpType.LANDING);
        break;
      case "/tasks":
        setHelp(HelpType.TASKS);
        break;
      case "/batch":
        setHelp(HelpType.TASKS); // Use the same help type for batch tasks
        break;
      case "/images":
        setHelp(HelpType.IMAGES);
        break;
      default:
        setHelp(HelpType.LANDING);
    }
  };

  return (
    <Box
      position="static"
      className={isHome ? "navbar navbar-home" : "navbar"}
      // style={!isHome ? {
      //     backgroundImage: `url(${background})`,
      // } : {}}
    >
      <Box className="navbar-logo">
        <a href="/">xLungs  </a>
      </Box>
      <Toolbar>
        <Typography variant="h6" style={{ flexGrow: 1 }} className="navbar-links">
          <a href="https://xlungs.mi2.ai/" className="navbar-link" target="_blank" rel="noopener noreferrer">
            About
          </a>
          {authenticated && (
            <a href="/tasks" className="navbar-link">
              Tasks
            </a>
          )}
          {authenticated && (
            <a href="/batch" className="navbar-link">
              Batch Tasks
            </a>
          )}
          {authenticated && (
            <a href="/images" className="navbar-link">
              Images
            </a>
          )}
          {authenticated && (
            <button
              className="navbar-link"
              onClick={() => {
                sessionStorage.clear();
                setAuthenticated(false);
                logout().then(() => {
                  window.location.href = "/";
                });
              }}
            >
              Logout
            </button>
          )}
          <IconButton
            onClick={() => {
              handleHelpClick();
            }}
          >
            <HelpIcon />
          </IconButton>
        </Typography>
      </Toolbar>
    </Box>
  );
};
